/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EditBusinessType } from './editBusinessType';
import { ContactForOrganisationEdit } from './contactForOrganisationEdit';
import { EditOrganisationProfileExt } from './editOrganisationProfileExt';


/**
 * Профиль организации.
 */
export interface OrganisationView { 
    /**
     * Кратное наименование организации.
     */
    shortName?: string;
    /**
     * Полное наименование организации.
     */
    fullName?: string;
    /**
     * Идентификатор родительской организации.
     */
    parentOrganisation?: string;
    /**
     * Кол-во сотрудников.
     */
    numberOfEmployees?: number;
    /**
     * Наименование группы.
     */
    clusterName?: string;
    /**
     * ID фотографии.
     */
    photoId?: string;
    /**
     * Кол-во организаций объединения.
     */
    numberOfOrganisations?: number;
    /**
     * Дата оплаты членских взносов.
     */
    membershipPaidTill?: string;
    /**
     * Идентификатор фотографии.
     * @deprecated
     */
    photoIds?: Array<string>;
    /**
     * Кодовое имя для брендирования приложений ассоциации.
     */
    codeName?: string;
    /**
     * Идентификатор организации.
     */
    id?: string;
    /**
     * Отраслевая принадлежность (таблица BusinessForOrganisation).
     */
    businessTypes?: Array<EditBusinessType>;
    /**
     * ID регионов деятельности (справочник RegionsOKATO).
     */
    regionOKATOIDs?: Array<string>;
    /**
     * Контакты.
     */
    contacts?: Array<ContactForOrganisationEdit>;
    /**
     * Документы организации.
     */
    documentIds?: Array<string>;
    extended?: EditOrganisationProfileExt;
    /**
     * Оплата членских взносов произведена.
     */
    readonly isMembershipPaid?: boolean;
}

